import { createContext, useContext } from 'react';
import type { User } from '@/types';

export interface AdminLayoutContextType {
  user: User | null;
  isAdmin: boolean;
}

export const AdminLayoutContext = createContext<AdminLayoutContextType | undefined>(undefined);

export function useAdminContext() {
  const ctx = useContext(AdminLayoutContext);
  if (!ctx) throw new Error('useAdminContext must be used within AdminLayout');
  return ctx;
}
